import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Grid } from "@mui/material";

import { useSelector } from "react-redux";

import { getProcessingFeesFor } from "apis/reportAPIs";
import { feeDateWindow, formatFee, summariseFees } from "util/processingFeeUtils";

const toDate = (time) =>
  time && typeof time === "object" && "_seconds" in time ? new Date(time._seconds * 1000) : time;

// Processing fee (net of commission handed back on refunds) and refund cost of an online order.
// Informational only; renders as a grid item of the order page, nothing when both are 0.
const OrderProcessingFees = (props) => {
  const { orderNumber, createdAt } = props;
  const [fees, setFees] = useState(null);
  const user = useSelector((state) => state.account.user);
  const currencySymbol = user && user.currencySymbol ? user.currencySymbol : "$";

  useEffect(() => {
    setFees(null);
    if (!orderNumber) {
      return undefined;
    }
    let isCurrent = true;
    // An older server only answers by date: then the day before the order up to a month after it.
    getProcessingFeesFor({
      orderNumbers: [String(orderNumber)],
      fallbackWindow: feeDateWindow(createdAt ? toDate(createdAt) : new Date(), { daysBefore: 1 }),
    })
      .then((matched) => {
        if (isCurrent) {
          setFees(summariseFees(matched));
        }
      })
      .catch((error) => {
        console.error("getProcessingFeesFor", error);
      });
    return () => {
      isCurrent = false;
    };
    // createdAt only shapes the fallback window; the order number identifies the order.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNumber]);

  if (!fees || (fees.processingFee === 0 && fees.refundFee === 0)) {
    return null;
  }

  return (
    <Grid item lg={12} md={12} xl={9} xs={12}>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="processing fees">
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>Fees</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fees.processingFee !== 0 ? (
              <TableRow>
                <TableCell>Processing Fee: </TableCell>
                <TableCell align="left">{formatFee(fees.processingFee, currencySymbol)}</TableCell>
              </TableRow>
            ) : null}
            {fees.refundFee !== 0 ? (
              <TableRow>
                <TableCell>Refund Cost: </TableCell>
                <TableCell align="left">{formatFee(fees.refundFee, currencySymbol)}</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

OrderProcessingFees.propTypes = {
  orderNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdAt: PropTypes.any,
};

export default OrderProcessingFees;
